import { useEffect, useState } from 'react';
import { scrollStore } from '@/motion/scroll';

/** Once shown, the arrow stays until the page is back above this share of the threshold (no flicker at the edge). */
const KEEP_SHARE = 0.75;

/**
 * `true` once the page has scrolled past `viewports` × the viewport height, and it stays `true` until the
 * page is back above 75% of that distance — so a visitor scrolling up and down around the threshold
 * does not see the button blink out under the pointer (D-356). Reads the shared scroll store; state only
 * changes when the answer flips.
 */
export function useScrolledPast(viewports = 1): boolean {
  const [past, setPast] = useState(false);

  useEffect(
    () =>
      scrollStore.subscribe((scroll) => {
        const limit = scroll.viewportHeight * viewports;
        setPast((shown) => scroll.y > (shown ? limit * KEEP_SHARE : limit));
      }),
    [viewports],
  );

  return past;
}
